import React from "react";
import { withTheme } from "styled-components";
import BookSwimlane from "../../bookviews/book-swimlane";
import BridgeBook from "../../book/bridge-book";
import { withAllMatches } from "../../../../components/mediaquery/breakpoints";
import { t } from "../../../../core/translate";
import FetchingSpinner from "../../../../components/spinner/render-prop-spinner";

const RecentlyAddedLane = ({
  addedLoading,
  addedTitleKey,
  added,
  expandSwimlane
}) => {
  return (
    <FetchingSpinner
      loading={addedLoading}
      component={() => {
        return (
          <BookSwimlane
            isbns={added.map(asset => asset.vbid)}
            BookObject={BridgeBook}
            headerLabel={t(addedTitleKey, "Recently Added")}
            onHeaderClick={() =>
              expandSwimlane(added, t(addedTitleKey, "Recently Added"))
            }
            count={added.length}
            backArrow={t("page.explorer", "Explore")}
          />
        );
      }}
    />
  );
};
export default withAllMatches(withTheme(RecentlyAddedLane));
